//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      antifraudCurrencyId: null,
      antifraudLimit: null,
      isEnabled: true,
    };
  },

  computed: {
    ...mapState('currencies', ['currencies']),
    ...mapGetters('currencies', ['getCurrencyById']),
    ...mapState('transactionsSettings', ['data']),

    currentEquivalentTitle() {
      return this.getCurrencyById(this.data?.antifraudCurrencyId)?.title;
    },

    currentLimit() {
      return this.data?.antifraudLimit;
    },
  },

  async mounted() {
    this.setGeneralProgress(true);
    await this.getTransactionsSettings();
    this.setGeneralProgress(false);
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('transactionsSettings', {
      getTransactionsSettings: 'loadTransactionsSettings',
      updateTransactionsSettingsAction: 'updateTransactionsSettings',
    }),

    async applyFraudLimit() {
      if (this.antifraudCurrencyId && this.antifraudLimit) {
        try {
          this.setGeneralProgress(true);
          await this.updateTransactionsSettingsAction({
            antifraudCurrencyId: this.antifraudCurrencyId,
            antifraudLimit: this.antifraudLimit,
          });
          await this.getTransactionsSettings();
          this.setGeneralProgress(false);
          this.setSuccessNotification('Antifraud limit updated');
        } catch (error) {
          this.setErrorNotification(error);
        }
      }
    },
  },
};
